import classNames from 'clsx';
import React from 'react';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getSpaceLossText } from 'reactApp/sections/SubscriptionsPage/ui/CreditCard/CreditCard.helpers';
import Lottie from 'reactApp/ui/Lottie/Lottie';
import unlinkCardModalStyles from 'reactApp/ui/UnlinkCardConfirmModal/UnlinkCardConfirmModal.css';
import { formatDaysLeft } from 'reactApp/utils/formatDate';

import cardUnlinkTrialAnimation from './cardUnlinkTrialAnimation.json';
import cardUnlinkTrialAnimationMobile from './cardUnlinkTrialAnimationMobile.json';
import styles from './CardUnlinkTrialModalContent.css';

interface TrialModalHeaderProps {
    expires: number;
}

export const TrialModalHeader = ({ expires }: TrialModalHeaderProps) => {
    const isMobile = EnvironmentSelectors.isMobile();
    return (
        <div className={classNames(styles.trialHeader, { [styles.trialHeaderMobile]: isMobile })}>
            <Lottie
                className={classNames(styles.trialAnimation, { [styles.trialAnimationMobile]: isMobile })}
                animationData={isMobile ? cardUnlinkTrialAnimationMobile : cardUnlinkTrialAnimation}
                loop
                autoplay
            />
            <div className={classNames({ [styles.trialTitleMobile]: isMobile })}>
                Без карты {formatDaysLeft(expires)} пробной подписки{' '}
                {expires - Date.now() < 2 * 24 * 60 * 60 * 1000 ? 'отключится' : 'отключатся'}
            </div>
        </div>
    );
};

interface TrialModalContentProps {
    space: { value: string; space: number };
}

export const TrialModalContent = ({ space }: TrialModalContentProps) => {
    const isMobile = EnvironmentSelectors.isMobile();
    return (
        <div className={classNames({ [styles.trialContentMobile]: isMobile })}>
            <p className={unlinkCardModalStyles.text}>Что изменится</p>
            <ul className={unlinkCardModalStyles.list}>
                <li>{getSpaceLossText(space)} дополнительного места</li>
                <li>Не загрузятся файлы больше 2 ГБ</li>
                <li>Вернётся реклама в Почте и Облаке</li>
            </ul>
        </div>
    );
};
